<div class="relative" style="min-height: 100px;">
  <div class="filters flex align-items-center mb-4">
    <span>filtros:</span>
      <ng-container *ngFor="let filter of filterArray?.filters">
        <ng-container  [ngSwitch]="filter.type">
          <ng-container *ngSwitchCase="'FILTER'">
              <ng-container *ngFor="let data of filter.data; let position = index">
                <p-chip  class="ml-2"  [label]="data.name"></p-chip>
              </ng-container>
            </ng-container>
              
          <ng-container *ngSwitchCase="'DATE'">
            <p-chip *ngIf="filter.data && filter.data.length > 0"  class="ml-2"  label="{{filter.data[0].name | date:'dd/MM/yyyy'}} - {{filter.data[1].name | date:'dd/MM/yyyy'}}"></p-chip>
          </ng-container>
        </ng-container>
      </ng-container>
  </div>

  <table #table class="standard w-full">
     <thead>
        <tr class="header"*ngFor="let subHeader of parentHeaders; let i = index">
            <ng-container
              *ngTemplateOutlet="subHeader">
            </ng-container>
        </tr>
        <tr>
          <th *ngFor="let header of headers; let i = index">
              <ng-container
                *ngTemplateOutlet="header">
              </ng-container>
          </th>
          <th *ngIf="expands.length > 0"></th>
        </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let dadosLinha of dados; let position = index">
          <tr class="pl-1" [ngClass]="{'expandd': expandBody[position]}"  >
            <td *ngFor="let coluna of colunas; let i = index" [style.width.%]="this.widthColumns[i]">
              <ng-container
                  *ngTemplateOutlet="coluna; context: { dadosLinha, position }">
                </ng-container>
            </td>
            <td *ngIf="expands.length > 0" style="width: 0%;">
                <p-button  (click)="expandInfo(position)"  [rounded]="true" [text]="true" >
                  <ng-template pTemplate="icon">
                    <div class="flex">
                        <i class="pi pi-chevron-circle-down" [ngClass]="{'active': expandBody[position]}" style="font-size: 20px;"></i>
                    </div>
                  </ng-template>
                </p-button>
              </td>
          </tr>
          <tr class="expand" *ngFor="let expand of expands" [ngClass]="{'show': expandBody[position]}">
              <ng-container
                *ngTemplateOutlet="expand; context: { dadosLinha }">
              </ng-container>
          </tr>
        </ng-container>
      </tbody>
  </table>

  
  <!--<table #table class="w-full" [ngClass]="theme">
      <thead>
        <tr class="header">
          <ng-container *ngFor="let header of parentHeaders; let i = index">
               <ng-container
                *ngTemplateOutlet="header">
              </ng-container>
          </ng-container>
        </tr>
        <tr class="header">
            <th *ngFor="let header of headers; let i = index">
              <div [ngClass]="{'flex gap-2 align-items-center': i == 0}">
                <p-checkbox *ngIf="checklist && i == 0" [ngModel]="isAllChecked()" (onChange)="checkAll($event)" [binary]="true" inputId="binary"  (onChange)="emitEventChecked()"></p-checkbox>
                <ng-container
                  *ngTemplateOutlet="header">
                </ng-container>
            </div>
            </th>
            <th *ngIf="expands.length > 0"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let dadosLinha of dados; let position = index">
            <tr class="pl-1" [ngClass]="{'expandd': expandBody[position]}" >
              <td *ngFor="let coluna of colunas; let i = index" [style.width.%]="this.widthColumns[i]">
                <div [ngClass]="{'flex gap-2 align-items-center': i == 0}">
                  <p-checkbox (onChange)="emitEventChecked()" [(ngModel)]="dadosLinha.checklist" *ngIf="checklist && i == 0" [binary]="true" inputId="binary"></p-checkbox>
                    <ng-container
                        *ngTemplateOutlet="coluna; context: { dadosLinha, position }">
                    </ng-container>
                </div>
              </td>
              <td *ngIf="expands.length > 0" style="width: 0%;">
                <p-button  (click)="expandInfo(position)"  [rounded]="true" [text]="true" >
                  <ng-template pTemplate="icon">
                    <div class="flex">
                        <i class="pi pi-chevron-circle-down" [ngClass]="{'active': expandBody[position]}" style="font-size: 20px;"></i>
                    </div>
                  </ng-template>
                </p-button>
              </td>
          </tr>
          <tr class="expand" *ngFor="let expand of expands" [ngClass]="{'show': expandBody[position]}">
            <ng-container
              *ngTemplateOutlet="expand; context: { dadosLinha }">
            </ng-container>
          </tr>
        </ng-container>
        <tr *ngFor="let linha of linhas" >
          <ng-container
                *ngTemplateOutlet="linha; context: { dados }">
          </ng-container>
        </tr>
      </tbody>

  </table>-->
  <div class="mt-2">
    <p-paginator *ngIf="paginator" #pPaginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"></p-paginator>
  </div>
  <div class="loading" *ngIf="loading">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
</div>
